<template>
  <div
    v-if="item.visible"
    class="cardview"
    :class="[
      `bg-${bgColor}`,
      {
        'cardview--active': item.active,
      },
      itemClass,
    ]"
    @click="$emit('selected', { ...item })"
  >
    <div class="d-flex mb-2">
      <span class="cardview__count" :class="`color-${color}`">
        {{ item.count }}
      </span>
      <img v-if="icon" :src="icon" />
      <em v-else :class="`fa fa-circle color-${color}`" />
    </div>
    <div>
      <span class="font-12 font-weight-bold color-dark-blue d-block">
        {{ $t('Status.HeaderText') }}
      </span>
      <span class="cardview__title" :class="`color-${color}`">
        {{ title }}
      </span>
    </div>
  </div>
</template>

<script>
//constants
import {
  requestStatusColor,
  requestStatusBgColor,
} from '@/utils/constants/requestStatus.js';

import lang from '@/utils/constants/lang';

export default {
  name: 'Card',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    itemClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    color() {
      return requestStatusColor[this.item.statusId];
    },
    bgColor() {
      return requestStatusBgColor[this.item.statusId];
    },
    icon() {
      return this.item.icon || null;
    },
    title() {
      return this.userSelectedLang === lang.ES
        ? this.item.title
        : this.item.titleEn;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
.cardview {
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 5px;
  cursor: pointer;
  padding: 10px 15px;

  &__count {
    flex: 1;
    font-size: 3rem;
    font-weight: bold;
  }
  &__title {
    font-size: 1rem;
    text-align: center;
  }
  &--active {
    border: unset;
    background: map-get($colors, 'primary-1');
    .cardview__count,
    .cardview__title {
      color: map-get($colors, 'white');
    }
  }
}
</style>
